import AddIcon from "@assets/icons/plus.svg";
import HctIcon from "@assets/icons/patients-list.svg";
import { useI18n } from "@core/i18n/i18n";
import { e2eTestId } from "@e2e/test-ids";
import styled from "@emotion/styled";
import { row } from "@ui/style";
import React from "react";
import { IconCardButton } from "@ui/components/common/icon-card-button";

interface InviteOrCreatePatientProps {
	createPatient: () => void;
	joinHct: () => void;
	disabled?: boolean;
	className?: string;
}

export const InviteOrCreatePatient: React.FC<InviteOrCreatePatientProps> = ({
	createPatient,
	joinHct,
	disabled,
	className,
}) => {
	const { format } = useI18n();

	return (
		<Container className={className}>
			<StyledIconCardButton
				onClick={createPatient}
				icon={AddIcon}
				label={format("home.addPatientDialog.inviteOrCreate.createPatient")}
				disabled={disabled}
				data-test={e2eTestId.createPatientDialog.createPatientCTA}
			/>
			<StyledIconCardButton
				onClick={joinHct}
				icon={HctIcon}
				label={format("home.addPatientDialog.inviteOrCreate.joinHct")}
				disabled={disabled}
			/>
		</Container>
	);
};

const StyledIconCardButton = styled(IconCardButton)`
	flex: 1;
	align-self: stretch;
	padding: 24px 16px;
`;

const Container = styled.div`
	${row("SM")}
`;
